import { render, staticRenderFns } from "./match-recommend.vue?vue&type=template&id=50f2dade&scoped=true"
import script from "./match-recommend.vue?vue&type=script&lang=js"
export * from "./match-recommend.vue?vue&type=script&lang=js"
import style0 from "./match-recommend.vue?vue&type=style&index=0&id=50f2dade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f2dade",
  null
  
)

export default component.exports